module.exports = __webpack_public_path__ + "img/high-tier-poster-image.83d23f48.jpg";